import React from "react";
import "./index.css";
import { buildHerbAgencyUrl } from "@herb/utils/herbAgencyUrl";

const AnnouncementBar = () => {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const announcementBarUrl = buildHerbAgencyUrl({
    utmContent: "announcement-bar"
  });
  return (
    <div className="announcement-bar">
      <a
        href={isMobile ? announcementBarUrl : ""}
        className="announcement-bar-text"
      >
        Need help growing your cannabis brand? Work with Herb Agency!
      </a>
      <a className="announcement-bar-cta" href={announcementBarUrl}>
        Get in Touch →
      </a>
    </div>
  );
};

export default AnnouncementBar;
